import {makeReactContext} from 'lib/makeReactContext';
import {PlateDataParameter} from 'samples/plate-maps/PlateMapConstants';

export interface PlateDataParameterContextType {
  plateDataParameters: Array<PlateDataParameter>;
}

/**
 * This context passes a list of plate data parameters into PlateProcedureParameterLayerSelector. We
 * don't pass it in directly because the component that would render that dropdown is also rendered in a
 * frozen plate map summary where we don't have access to live parameters.
 */
export const PlateDataParameterContext = makeReactContext<PlateDataParameterContextType>(
  () => ({
    plateDataParameters: [],
  }),
  'PlateDataParameterContext'
);

export function usePlateDataParameterContext(): PlateDataParameterContextType {
  return PlateDataParameterContext.useContext();
}
